import { useFetch } from "../../hooks/useFetch";
import { money } from "../../lib/api";
import { Loading } from "../../components/States";
import { PageHeader } from "../../components/PageHeader";
import { StatCard } from "../../components/StatCard";
import { useAuth } from "../../context/AuthContext";
import { Building2, Home, FileSignature, DollarSign, CalendarCheck } from "lucide-react";

export default function BuilderDashboard() {
  const { data, loading } = useFetch("/dashboard/builder");
  const { user } = useAuth();
  if (loading || !data) return <Loading />;

  return (
    <div className="space-y-8">
      <PageHeader
        eyebrow={user?.name}
        title="Builder Dashboard"
        subtitle={`${data.active_lots} active lots across ${data.communities} communities. ${data.pending_change_orders} change orders awaiting your signature.`}
      />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <StatCard testid="b-communities" label="Communities" value={data.communities} icon={Building2} />
        <StatCard testid="b-lots" label="Active Lots" value={data.active_lots} icon={Home} />
        <StatCard testid="b-co" label="Change Orders" value={data.pending_change_orders} hint="Awaiting signature" icon={FileSignature} tone="warning" />
        <StatCard testid="b-balance" label="Open Balance" value={money(data.open_balance)} icon={DollarSign} />
      </div>
      <div className="hw-card p-6">
        <h3 className="mb-5 flex items-center gap-2 font-head text-xl font-bold text-white"><CalendarCheck size={18} className="text-cyan-400" /> Production by stage</h3>
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-5">
          {["rough-in", "service", "trim", "inspection", "final"].map((s) => (
            <div key={s} className="rounded-xl border border-slate-800 bg-slate-950/40 p-4 text-center">
              <div className="font-head text-3xl font-extrabold text-cyan-400">{data.stage_breakdown[s] || 0}</div>
              <div className="mt-1 text-xs font-mono2 uppercase text-slate-500">{s.replace("-", " ")}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
